import './style.css'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { isDetachedModeEnabled, isFocusModeEnabled } from 'data/ui/selectors'
import { getSearchState, exit as exitSearch } from 'data/search'
import Scrollable from 'components/Utils/Scrollable'
import { TOP_BAR_HEIGHT } from 'screens/Topbar/TopBarRight'
import Metabar from 'screens/Metabar'

export const EDITOR_CONTENT = 'note-content'
export const NOTE_VIEW_ID = 'note-view'
export const NOTE_HEADER_HEIGHT = 60
export const CENTERED_CONTENT_CLASSNAME = 'note-view-centered-content'

const HEADER_STYLE_WITH_TOP_BAR = {
  height: `calc(100vh - ${TOP_BAR_HEIGHT}px)`,
} // Fix needed for safari grid overflow
const HEADER_STYLE_WITHOUT_TOP_BAR = { height: '100vh' }
const SCROLLABLE_STYLE = { gridArea: 'content' }
const CONTENT_STYLE = { marginTop: 40 }
const FOOTER_STYLE = { gridArea: 'footer' }
const METABAR_STYLE = {
  top: 20,
  right: 16,
  bottom: 16,
  width: 32,
}

type NoteViewProps = {
  header?: React.ReactNode
  footer?: React.ReactNode
  contentClassName?: string
  children: React.ReactNode
  setScrolling?: () => void
}

const NoteView: React.FC<NoteViewProps> = ({
  header,
  footer,
  children,
  setScrolling,
  contentClassName = CENTERED_CONTENT_CLASSNAME,
}) => {
  const isDetachedMode = useSelector(isDetachedModeEnabled)
  const searchIsActive = useSelector(state => getSearchState(state).isActive)
  const isFocusMode = useSelector(isFocusModeEnabled)
  const dispatch = useDispatch()

  const onWrapperClick = React.useCallback(
    () => {
      if (searchIsActive) {
        dispatch(exitSearch())
      }
    },
    [dispatch, searchIsActive]
  )

  return (
    <div
      id={NOTE_VIEW_ID}
      className="note-view overflow-hidden position-relative flexbox-grow zindex-small"
      onClick={onWrapperClick}
      style={
        isFocusMode || isDetachedMode
          ? HEADER_STYLE_WITHOUT_TOP_BAR
          : HEADER_STYLE_WITH_TOP_BAR
      }
    >
      {header}

      <Scrollable
        id={EDITOR_CONTENT}
        className="overflow-auto background-shade-100"
        scrollingClassName=""
        innerClassName="overflow-hidden"
        onScrollingChange={setScrolling}
        style={SCROLLABLE_STYLE}
      >
        <div className={contentClassName} style={CONTENT_STYLE}>
          {children}
        </div>
      </Scrollable>

      <div style={FOOTER_STYLE}>{footer}</div>

      <div className="position-absolute" style={METABAR_STYLE}>
        <Metabar />
      </div>
    </div>
  )
}

export default React.memo(NoteView)
